import { InjectionToken } from '@angular/core';

export const NOMINATIM_USER_AGENT = new InjectionToken<string>('NOMINATIM_USER_AGENT', {
  providedIn: 'root',
  factory: () => 'NOXO P2P Investment Platform',
});
